(function () {
  'use strict';

  const CONFIG_ID = "LSCustomMasturbatorConfig";

  function readConfig() {
    const node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('[Love Smiths] Invalid custom masturbator configuration:', error);
      return null;
    }
  }

  function init(config) {
    if (!config || !config.sectionId) return;
    window.customizerStrings = config.strings || {};
/* ---------- Gallery ---------- */
      const thumbnails = document.querySelectorAll(".thumbnail");
      const mainBanner = document.getElementById("main-banner");

      function swapMainSrc(newSrc) {
        if (!mainBanner || !newSrc) return;
        mainBanner.classList.add("is-fading");

        const img = new Image();
        img.onload = () => {
          mainBanner.src = newSrc;
          mainBanner.srcset = newSrc;
          mainBanner.removeAttribute("sizes");
          requestAnimationFrame(() => mainBanner.classList.remove("is-fading"));
        };
        img.onerror = () => mainBanner.classList.remove("is-fading");
        img.src = newSrc;
      }

      thumbnails.forEach(t => {
        t.addEventListener("click", function() {
          thumbnails.forEach(x => x.classList.remove("selected"));
          this.classList.add("selected");
          swapMainSrc(this.getAttribute("data-large") || this.getAttribute("src"));
        });
      });

      
      /* ---------- Mobile swipe ---------- */
      (function() {
        if (!mainBanner) return;

        const thumbs = Array.from(document.querySelectorAll(".thumbnail"));
        if (!thumbs.length) return;

        let currentIndex = Math.max(0, thumbs.findIndex(el => el.classList.contains("selected")));
        if (currentIndex === -1) currentIndex = 0;

        let startX = 0, startY = 0, swiping = false;

        function goTo(idx) {
          currentIndex = (idx + thumbs.length) % thumbs.length;
          const t = thumbs[currentIndex];
          thumbs.forEach(x => x.classList.remove("selected"));
          t.classList.add("selected");

          const newSrc = t.getAttribute("data-large") || t.getAttribute("src");
          swapMainSrc(newSrc);
        }

        mainBanner.addEventListener("touchstart", (e) => {
          if (!e.touches || !e.touches.length) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          swiping = true;
        }, { passive: true });

        mainBanner.addEventListener("touchmove", (e) => {
          if (!swiping) return;
          const dx = e.touches[0].clientX - startX;
          const dy = e.touches[0].clientY - startY;
          if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
            e.preventDefault();
          }
        }, { passive: false });

        mainBanner.addEventListener("touchend", (e) => {
          if (!swiping) return;
          swiping = false;

          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;

          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) goTo(currentIndex + 1);
            else goTo(currentIndex - 1);
          }
        });
      })();

      /* ---------- Form ---------- */
      const form = document.getElementById(`product-form-${config.sectionId}`);
      const hiddenInput = form.querySelector('input[name="id"]');
      const addToCartBtn = document.getElementById(`add-to-cart-${config.sectionId}`);
      const hint = document.getElementById(`selection-hint-${config.sectionId}`);
      const defaultHintText = hint ? hint.textContent.trim() : "";

      const propPour = document.getElementById("prop-pour-style");
      const propC1 = document.getElementById("prop-colour-1");
      const propC2 = document.getElementById("prop-colour-2");
      const propC3 = document.getElementById("prop-colour-3");

      const customPanel = document.getElementById("customisation-panel");
      const pourInfoFrame = document.getElementById("pour-style-info-frame");
      const swatchSetsContainer = document.getElementById("swatch-sets");
      const prototype = document.getElementById("swatch-prototype");
      const swatchSource = document.getElementById("swatch-source");
      const livePreview = document.getElementById("live-preview");
      const instructionEl = document.getElementById("preview-instructions");
      const priceEls = document.querySelectorAll(".sticky-cart-price");
      const defaultPriceHTML = priceEls.length ? priceEls[0].innerHTML : "";
      const variants = Array.isArray(config.variants) ? config.variants : [];

      const availableVariants = (variants || []).filter(v => v && v.available);
      const optionBtns = form.querySelectorAll(".option-btn[data-variant='true']");

      function setCartVisibility(showButton, hintText = defaultHintText) {
        if (addToCartBtn) {
          addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
          addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
        }

        if (hint) {
          hint.hidden = showButton;
          if (!showButton && hintText) {
            hint.textContent = hintText;
          }
        }
      }

      function arraysEqualCI(a, b) {
        if (!a || !b || a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
          if (String(a[i]).toLowerCase() !== String(b[i]).toLowerCase()) return false;
        }
        return true;
      }
      function findActiveOptionButton(optionName) {
        return Array.from(form.querySelectorAll('.option-btn[data-original-option].active'))
          .find(button => button.dataset.originalOption === optionName) || null;
      }

      function getSelectedVariantOptions() {
        const selected = [];
        (config.optionNames || []).forEach(optionName => {
          const element = findActiveOptionButton(optionName);
          if (element) selected.push(element.dataset.value);
        });
        return selected;
      }

      function updateVariantId() {
        const selected = getSelectedVariantOptions();
        if (selected.length !== config.optionCount) {
          hiddenInput.value = "";
          return;
        }

        const match = variants.find(v => arraysEqualCI(v.options, selected));
        hiddenInput.value = match ? match.id : "";
      }
      function getCurrentSelectionsByIndex() {
        const selected = Array(config.optionCount).fill(null);

        (config.optionNames || []).forEach((optionName, optionIndex) => {
          const button = findActiveOptionButton(optionName);
          if (button) selected[optionIndex] = button.dataset.value;
        });

        return selected;
      }

      function variantMatchesWithCandidate(variant, selections, candidateIndex, candidateValue) {
        if (!variant || !variant.options) return false;

        for (let i = 0; i < selections.length; i++) {
          const want = (i === candidateIndex) ? candidateValue : selections[i];
          if (!want) continue;

          const got = variant.options[i];
          if (String(got).toLowerCase() !== String(want).toLowerCase()) return false;
        }
        return true;
      }

      function isValueAvailableForIndex(optionIndex, value, selections) {
        return availableVariants.some(v => variantMatchesWithCandidate(v, selections, optionIndex, value));
      }

      function updateOptionAvailability() {
        const selections = getCurrentSelectionsByIndex();

        form.querySelectorAll('.option-btn[data-variant="true"]').forEach(btn => {
          const frame = btn.closest(".variant-frame");
          if (!frame) return;

          const optionIndex = parseInt(frame.getAttribute("data-option-index") || "", 10);
          if (Number.isNaN(optionIndex)) return;

          const value = btn.dataset.value;
          const ok = isValueAvailableForIndex(optionIndex, value, selections);

          btn.disabled = !ok;
          btn.classList.toggle("is-disabled", !ok);

          if (!ok && btn.classList.contains("active")) {
            btn.classList.remove("active");
            btn.setAttribute("aria-pressed", "false");
          }
        });

        updateVariantId();
      }

      function getSelectedColourCount() {
        const countBtn = form.querySelector('.option-btn[data-option-group="colorcount"].active');
        if (!countBtn) return 0;

        const raw = countBtn.dataset.value || countBtn.textContent || "";
        const m = raw.match(/\d+/);
        return m ? parseInt(m[0], 10) : 0;
      }

      function clearProperties() {
        propPour.value = "";
        propC1.value = "";
        propC2.value = "";
        propC3.value = "";
      }

      function hydrateSwatches(root) {
        const rows = root.querySelectorAll(".swatch-row");
        rows.forEach(row => {
          const candidates = row.querySelectorAll(".swatch");
          candidates.forEach(el => {
            const img = el.querySelector("img");
            const name =
              el.dataset?.colourName ||
              (img ? img.alt : "") ||
              (el.textContent || "").trim();

            if (!name) return;

            el.classList.add("swatch");
            if (!el.dataset.colourName) el.dataset.colourName = name;
            el.setAttribute("role", "button");
            if (!el.hasAttribute("aria-pressed")) el.setAttribute("aria-pressed", "false");
          });
        });
      }

      function makeSwatchSet(heading, maxSelect) {
        const clone = prototype.cloneNode(true);
        clone.removeAttribute("id");
        clone.style.display = "";
        clone.querySelector(".swatch-heading").textContent = heading;
        clone.dataset.maxSelect = maxSelect;

        const row = clone.querySelector(".swatch-row");
        row.innerHTML = "";

        if (swatchSource) {
          let subCats = swatchSource.querySelectorAll(".sub-swatch-category");
          if (!subCats.length) subCats = swatchSource.querySelectorAll(".swatch");

          if (subCats.length) {
            subCats.forEach(cat => {
              const catClone = cat.cloneNode(true);
              row.appendChild(catClone);
            });
          } else {
            const p = document.createElement("p");
            p.textContent = "No swatches available.";
            p.style.color = "#aaa";
            row.appendChild(p);
          }
        }

        hydrateSwatches(clone);
        return clone;
      }

      function updateLivePreview() {
        if (!livePreview) return;

        const selectedImgs = swatchSetsContainer.querySelectorAll(".swatch.active img");
        livePreview.innerHTML = "";
        const frag = document.createDocumentFragment();

        if (selectedImgs.length === 0) {
          const placeholder = document.createElement("div");
          placeholder.className = "preview-swatch";
          const placeholderImage = document.createElement("img");
          placeholderImage.src = config.placeholderUrl || "";
          placeholderImage.alt = config.previewAlt || "";
          placeholder.appendChild(placeholderImage);
          frag.appendChild(placeholder);
        } else {
          selectedImgs.forEach(img => {
            const wrapper = document.createElement("div");
            wrapper.className = "preview-swatch";
            wrapper.style.cursor = "pointer";

            const clone = img.cloneNode(true);
            wrapper.appendChild(clone);

            const colourName = img.alt || "";
            if (colourName) {
              const nameTag = document.createElement("span");
              nameTag.className = "preview-colour-name";
              nameTag.textContent = colourName;
              wrapper.appendChild(nameTag);
            }

            wrapper.addEventListener("click", () => {
              const firstSet = document.querySelector("#swatch-sets .swatch-set");
              if (!firstSet) return;
              if (window.expandSwatchSet) window.expandSwatchSet(firstSet);

              const activeSwatch = firstSet.querySelector(".swatch.active") || firstSet.querySelector(".swatch");
              const scrollTarget = activeSwatch || firstSet;

              scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
            });

            frag.appendChild(wrapper);
          });
        }

        livePreview.appendChild(frag);
      }

      function renderSwatchSets(count) {
        customPanel.style.display = "";
        swatchSetsContainer.innerHTML = "";
        clearProperties();
        updateLivePreview();

        if (count === 1) {
          pourInfoFrame.style.display = "none";
          swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_one, 1));
          return;
        }

        if (count === 2) {
          pourInfoFrame.style.display = "";
          swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_two_marble, 2));
          return;
        }

        if (count === 3) {
          pourInfoFrame.style.display = "";
          swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_three_marble, 3));
          return;
        }

        pourInfoFrame.style.display = "none";
      }

      function validate() {
        const hasVariant = !!hiddenInput.value;
        const count = getSelectedColourCount();
        const selectedSwatches = swatchSetsContainer.querySelectorAll(".swatch.active");
        const coloursOk = count > 0 && selectedSwatches.length === count;

        clearProperties();

        if (hasVariant && coloursOk) {
          const allNames = [...selectedSwatches].map(sw =>
            sw.dataset.colourName || sw.querySelector("img")?.alt || ""
          );

          propC1.value = allNames[0] || "";
          propC2.value = allNames[1] || "";
          propC3.value = allNames[2] || "";
          propPour.value = count > 1 ? window.customizerStrings.auto_marble_label : "";
        }

        const ok = hasVariant && coloursOk;
        addToCartBtn.disabled = !ok;

        if (ok) {
          setCartVisibility(true);
        } else if (!hasVariant) {
          setCartVisibility(false, window.customizerStrings.validation_choose_all);
        } else {
          setCartVisibility(false, window.customizerStrings.validation_complete_colours);
        }

        if (instructionEl) {
          instructionEl.classList.remove("ready", "warning");

          if (!count) {
            instructionEl.textContent = window.customizerStrings.instr_start;
          } else if (count === 1) {
            instructionEl.textContent = coloursOk
              ? window.customizerStrings.instr_one_ready
              : window.customizerStrings.instr_one_pick;
            instructionEl.classList.add(coloursOk ? "ready" : "warning");
          } else if (count === 2) {
            instructionEl.textContent = coloursOk
              ? window.customizerStrings.instr_two_marble_ready
              : window.customizerStrings.instr_two_marble_pick;
            instructionEl.classList.add(coloursOk ? "ready" : "warning");
          } else if (count === 3) {
            instructionEl.textContent = coloursOk
              ? window.customizerStrings.instr_three_marble_ready
              : window.customizerStrings.instr_three_marble_pick;
            instructionEl.classList.add(coloursOk ? "ready" : "warning");
          }
        }
      }

      function updatePricePartial() {
        const selected = getSelectedVariantOptions();

        if (!selected.length) {
          priceEls.forEach(el => {
            el.innerHTML = defaultPriceHTML;
          });
          return;
        }

        const match = variants.find(v => arraysEqualCI(v.options, selected));
        if (!match) return;

        let html = "";
        if (
          match.formatted_compare_at_price &&
          Number(match.compare_at_price) > Number(match.price)
        ) {
          html = `
            <span class="price--compare"><s>${match.formatted_compare_at_price}</s></span>
            <span class="price--sale">${match.formatted_price}</span>
          `;
        } else {
          html = match.formatted_price || "";
        }

        priceEls.forEach(el => {
          el.innerHTML = html;
        });
      }

      /* ---------- Option buttons ---------- */
      optionBtns.forEach(btn => {
        btn.addEventListener("click", function() {
          const group = this.getAttribute("data-option-group");

          form.querySelectorAll(`.option-btn[data-option-group="${group}"]`).forEach(b => {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });

          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");

          if (group === "colorcount") {
            const count = getSelectedColourCount();
            renderSwatchSets(count);
            updateLivePreview();
          }

          updateOptionAvailability();
          updatePricePartial();
          validate();
        });
      });

      /* ---------- Swatches ---------- */
      swatchSetsContainer.addEventListener("click", function(e) {
        const sw = e.target.closest(".swatch");
        if (!sw) return;

        const setEl = sw.closest(".swatch-set");
        if (!setEl) return;

        const max = parseInt(setEl.dataset.maxSelect || "1", 10);

        if (sw.classList.contains("active")) {
          sw.classList.remove("active");
          sw.setAttribute("aria-pressed", "false");
        } else {
          if (max === 1) {
            setEl.querySelectorAll(".swatch.active").forEach(b => {
              b.classList.remove("active");
              b.setAttribute("aria-pressed", "false");
            });
          }

          if (setEl.querySelectorAll(".swatch.active").length < max) {
            sw.classList.add("active");
            sw.setAttribute("aria-pressed", "true");
          }
        }

        updateLivePreview();
        validate();

        const maxSel = parseInt(setEl.dataset.maxSelect || "1", 10);
        const chosen = setEl.querySelectorAll(".swatch.active").length;
        if (chosen >= maxSel && window.collapseSwatchSet) {
          setTimeout(() => window.collapseSwatchSet(setEl), 300);
        }

        setTimeout(() => {
          const btn = setEl.querySelector(".show-more-swatches");
          if (btn) {
            btn.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500);
      });

      /* ---------- More info accordion ---------- */
      document.addEventListener("click", function(e) {
        const btn = e.target.closest(".variant-more-info-btn");
        if (!btn) return;

        const key = btn.dataset.info;
        const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
        if (!target) return;

        const isOpen = target.classList.contains("open");

        document.querySelectorAll(".variant-more-info-content").forEach(section => {
          section.classList.remove("open");
        });

        document.querySelectorAll(".variant-more-info-btn").forEach(b => {
          if (b.dataset.info === "pour-style") {
            b.textContent = window.customizerStrings.pour_show_example;
          } else {
            b.textContent = window.customizerStrings.more_info;
          }
          b.setAttribute("aria-expanded", "false");
        });

        if (!isOpen) {
          target.classList.add("open");
          if (btn.dataset.info === "pour-style") {
            btn.textContent = window.customizerStrings.pour_hide_example;
          } else {
            btn.textContent = window.customizerStrings.hide_info;
          }
          btn.setAttribute("aria-expanded", "true");
        }
      });

      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      setCartVisibility(false);
      updateOptionAvailability();
      validate();
  }

  function boot() {
    const config = readConfig();
    if (config) init(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
